import { DownloadOutlined, FileOutlined } from '@ant-design/icons';
import { getGetFrontRisorseCondiviseIdDownloadFileIdQueryKey } from '@framework/api-client';
import { useTranslation } from '@framework/i18n';
import { Button, Typography } from 'antd';
import styled from 'styled-components';
import { resolveApiPath } from '../../../core/appConfig';
import type { SharedResourceFile } from '../sharedResourceTypes';

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px;
  border: 1px solid ${props => props.theme.colorBorder ?? '#d9d9d9'};
  border-radius: 8px;
`;

const FileInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1;
`;

// Tronca con ellipsis i nomi file lunghi; il nome completo resta nel tooltip
// nativo (`title`) e nell'aria-label del pulsante.
const FileName = styled(Typography.Text)`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export interface SharedResourceFileRowProps {
  maskedId: string;
  file: SharedResourceFile;
}

export function SharedResourceFileRow(props: SharedResourceFileRowProps) {
  const { maskedId, file } = props;
  const { t } = useTranslation();

  const fileName = file.label || file.fileName;
  const openLabel = t('shared-resource.file-open', 'Apri');

  const [downloadPath] = getGetFrontRisorseCondiviseIdDownloadFileIdQueryKey(
    maskedId,
    file.fileId,
  );
  const downloadHref = resolveApiPath(downloadPath);

  return (
    <Row>
      <FileInfo>
        <FileOutlined aria-hidden />
        <FileName strong title={fileName}>
          {fileName}
        </FileName>
      </FileInfo>
      <Button
        type="default"
        icon={<DownloadOutlined aria-hidden />}
        href={downloadHref}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`${openLabel}: ${fileName}`}
        style={{ flexShrink: 0 }}
      >
        {openLabel}
      </Button>
    </Row>
  );
}
